import { SET_TIMECARD } from './timecard';

export const totals = (state = {}, action) => {
  switch (action.type) {
    case SET_TIMECARD:
      const totals = action.payload?.totals;
      if (totals) {
        return {
          billed: totals.billed,
          noCharge: totals.noCharge,
          workHours: totals.worked,
          vacationHours: totals.vacation,
          holidayHours: totals.holiday,
          sickHours: totals.sick,
        };
      } else {
        return {
          billed: 0,
          noCharge: 0,
          workHours: 0,
          vacationHours: 0,
          holidayHours: 0,
          sickHours: 0,
        };
      }
    default:
      return state;
  }
};
